<template>
  <div id="v-fields-empresasusuarios">
    <v-layout row wrap>
      <v-flex xs12>
        <MdSelect
          :disable="gridConfig.isDeleteModal"
          :validation="['required']"
          ref="idEmpresa"
          name="idEmpresa"
          label="Empresa"
          v-model="gridConfig.editedItem.id_empresa"
          autocomplete
          :items="empresas"
          itemText="nome"
          itemValue="id"
        ></MdSelect>
      </v-flex>
      <v-flex xs12>
        <MdSelect
          :disable="gridConfig.isDeleteModal"
          :validation="['required']"
          ref="idUsuario"
          name="idUsuario"
          label="Usuário"
          v-model="gridConfig.editedItem.id_usuario"
          autocomplete
          :items="usuarios"
          itemText="nome"
          itemValue="id"
        ></MdSelect>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "v-fields-empresasusuarios",

  props: {
    gridConfig: {},
    usuarios:{type: Array, default: null},
    empresas:{type: Array, default: null},
    exclusao: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },

  created() {},

  methods: {
  },
};
</script>

<style>
</style>
